module.exports = __webpack_public_path__ + "static/media/mai4.08047848.jpg";